module.exports = __webpack_public_path__ + "img/bg_underground_lab.b246946a.jpg";